import { TitleButton } from '@/common/buttons/TitleButton';
import { useModuleFromRoute } from '@/common/hooks/route/useModuleFromRoute';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';

export const resolveLifecycle = (entityObj) => {
    return { pluginCode: 'MCO_INV_LIFECYCLE_ACTION_PLUGIN', title: 'Managed Care Invoice Lifecycle' };
};

export const McoInvLifecycleButton = ({ selectedEntities }) => {
  const rsrc = useRsrc();
  const module = useModuleFromRoute();

  const lifecycles = selectedEntities.map(resolveLifecycle);
  const firstLifecycle = lifecycles[0];
  const allSame = firstLifecycle && lifecycles.every((lc) => lc?.pluginCode === firstLifecycle?.pluginCode);

  const disabled = selectedEntities.length === 0 || !allSame;

  const runLifecycle = () => {
    const ids = selectedEntities.map((e) => e.id);

    const job = {
      code: firstLifecycle.pluginCode.replace('_ACTION_PLUGIN', ''),
      name: firstLifecycle.title,
      module,
      entity: 'MCO_INV',
      entityId: ids.length === 1 ? ids[0] : undefined,
      rsrcCode: firstLifecycle.pluginCode,
      reqParamJson: JSON.stringify({ ids }),
      cat: 'ACTION'
    };

    rsrc.save('skdr', 'JOB', job).then((job) => {
      rsrc.start(job.id);
    });
  };

  const toolTip = 'Run Lifecycle';

  return (
    <TitleButton
      dataTestId="mco-inv-lifecycle-button"
      icon={fas.faPlay}
      toolTip={toolTip}
      disabled={disabled}
      onClick={runLifecycle}
    />
  );
};
